import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row, Spinner } from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";

import { ToastContainer, toast } from "react-toastify";

// Alt Bileşenler (Dosya yollarını kendi projenize göre ayarlayın)
import FinansIstatistikleri from "./walletStats";
import FinansGrafik from "./walletOverView";
import SonIslemler from "./walletActivities";

const SistemFinans = () => {
  document.title = "Sistem Finans Özeti | LojGo Admin";

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = authUser?.Users_Type_ID === 3;

  const [isLoading, setIsLoading] = useState(true);
  const [stats, setStats] = useState({
    totalRevenue: 0,
    pendingPayments: 0,
    completedTrips: 0,
    walletHistory: []
  });

  useEffect(() => {
    const fetchSystemStats = async () => {
      setIsLoading(true);
      try {
        if (!isAdmin) {
          toast.error("Bu sayfayı görüntüleme yetkiniz yok.");
          setIsLoading(false);
          return;
        }

        // LojGo sistemindeki İlanları (Advert) çekiyoruz.
        const advResponse = await fetch("https://hiflowapi.stechomeyazilim.info/Advert?$orderby=Created_DateTime desc");
        const advResult = await advResponse.json();

        let totalRev = 0;
        let pending = 0;
        let completed = 0;
        let history = [];

        if (advResult && advResult.value) {
          advResult.value.forEach(item => {
            const price = parseFloat(item.Price) || 0;
            
            // Fiyatı olanları hesaplamaya dahil et
            if (price > 0) {
              totalRev += price;
            }

            // Duruma göre bekleyen veya tamamlananları hesapla
            // (Advert_Status kolonunuz varsa ona göre güncelleyin, şu an varsayımsal hesaplıyoruz)
            if (item.Advert_Status === "Bekliyor" || !item.Advert_Status) {
              pending += price;
            } else if (item.Advert_Status === "Tamamlandı") {
              completed += 1;
            }
            
            // Tablo için son işlemleri oluştur (En fazla 50 kayıt alalım ki performansı düşürmesin)
            if (history.length < 50 && price > 0) {
              history.push({
                idno: `LOJ-${item.ID}`,
                date: item.Created_DateTime,
                type: (item.Advert_Status === "Tamamlandı" || item.Is_Active) ? "Gelir" : "Bekleyen",
                user: item.Customer_Notes || "Bilinmiyor",
                amount: price,
                status: item.Advert_Status || (item.Is_Active ? "Onaylandı" : "İşlemde")
              });
            }
          });
        }

        setStats({
          totalRevenue: totalRev,
          pendingPayments: pending,
          completedTrips: completed,
          walletHistory: history
        });

      } catch (error) {
        console.error("Finans veri hatası:", error);
        toast.error("Finans verileri yüklenirken hata oluştu.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchSystemStats();
  }, [isAdmin]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Finans" breadcrumbItem="Sistem Özeti" />
          
          {isLoading ? (
            <div className="text-center py-5"><Spinner color="primary"/></div>
          ) : (
            <>
              <Row>
                <Col xl="4">
                  <FinansIstatistikleri stats={stats} user={authUser} />
                </Col>
                
                <Col xl="8">
                  <Row>
                    <Col sm="4">
                      <Card className="mini-stats-wid shadow-sm border-0">
                        <CardBody>
                          <div className="d-flex">
                            <div className="me-3 align-self-center">
                              <i className="mdi mdi-cash-multiple h2 text-success mb-0" />
                            </div>
                            <div className="flex-grow-1">
                              <p className="text-muted mb-2">Toplam Sistem Cirosu</p>
                              <h5 className="mb-0">{stats.totalRevenue.toLocaleString('tr-TR')} TL</h5>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col sm="4">
                      <Card className="mini-stats-wid shadow-sm border-0">
                        <CardBody>
                          <div className="d-flex">
                            <div className="me-3 align-self-center">
                              <i className="mdi mdi-clock-outline h2 text-warning mb-0" />
                            </div>
                            <div className="flex-grow-1">
                              <p className="text-muted mb-2">Bekleyen Ödemeler</p>
                              <h5 className="mb-0">{stats.pendingPayments.toLocaleString('tr-TR')} TL</h5>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col sm="4">
                      <Card className="mini-stats-wid shadow-sm border-0">
                        <CardBody>
                          <div className="d-flex">
                            <div className="me-3 align-self-center">
                              <i className="mdi mdi-truck-check-outline h2 text-primary mb-0" />
                            </div>
                            <div className="flex-grow-1">
                              <p className="text-muted mb-2">Tamamlanan Sefer</p>
                              <h5 className="mb-0">{stats.completedTrips} Adet</h5>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>

                  <FinansGrafik />
                </Col>
              </Row>

              <Row>
                <Col lg="12">
                  <SonIslemler history={stats.walletHistory} />
                </Col>
              </Row>
            </>
          )}
        </Container>
      </div>
      <ToastContainer autoClose={2000} position="bottom-right" />
    </React.Fragment>
  );
};

export default SistemFinans;